export const getRecipeModalSteps = (t) => [
    {
        target: '[data-tour="rm-modal"]',
        placement: 'center',
        title: t('tour.recipeModal.step-welcome-title'),
        content: t('tour.recipeModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rm-names"]',
        title: t('tour.recipeModal.step-names-title'),
        content: t('tour.recipeModal.step-names-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rm-details"]',
        title: t('tour.recipeModal.step-details-title'),
        content: t('tour.recipeModal.step-details-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rm-ingredients"]',
        title: t('tour.recipeModal.step-ingredients-title'),
        content: t('tour.recipeModal.step-ingredients-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rm-footer"]',
        title: t('tour.recipeModal.step-footer-title'),
        content: t('tour.recipeModal.step-footer-content'),
        disableBeacon: true,
    },
];
